import { shallow } from 'zustand/shallow'

import { useReportStore } from '@/modules/report/useReportsStore'
import { DEFAULT_CHART_COLORS } from '@/modules/shared/constants/default-chart-colors'

export function useChartSalesByClientReport() {
  const { loading, jsonSalesByClient } = useReportStore(
    (state) => ({
      loading: state.loading,
      jsonSalesByClient: state.jsonSalesByClient,
    }),
    shallow,
  )

  const dataInfo = {
    labels: [],
    dataValue: [],
    bg: [],
    bc: [],
  }

  jsonSalesByClient?.cidades?.map((item, index) => {
    dataInfo.labels.push(item.cidade)
    dataInfo.dataValue.push(item.valor)

    dataInfo.bg.push(DEFAULT_CHART_COLORS[index].bg)
    dataInfo.bc.push(DEFAULT_CHART_COLORS[index].bc)

    return ''
  })

  const chartData = {
    labels: dataInfo.labels,
    options: {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
      },
    },
    datasets: [
      {
        label: 'Valor',
        data: dataInfo.dataValue,
        backgroundColor: dataInfo.bg,
        borderColor: dataInfo.bc,
      },
    ],
  }

  return {
    loading,
    jsonSalesByClient,
    chartData,
  }
}
